module.exports = __webpack_public_path__ + "img/girls_with_laptop.8ba3584b.svg";